import React from 'react';

import { PrivatePage } from '../../components/private-page';
import { ctGameDefault, ctGameTitle } from '../../constants/text';
import { ZoneLibraryGrid } from '../../features/zone-library-grid';

export const GlobalZoneLibraries = () => {
  React.useEffect(() => {
    document.title = ctGameTitle + ' - My Library';
    return () => {
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: '../dashboard' },
        { label: 'Global Zone Maps', href: '../global-zones' }
      ]}
      pageTitle={'Global Library'}>
      <ZoneLibraryGrid isGlobal />
    </PrivatePage>
  );
};
